import { NavLink } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <NavLink to="/faq" className="footer-link">FAQ</NavLink>
        <NavLink to="/privacy" className="footer-link">Privacy Policy</NavLink>
        <NavLink to="/contact" className="footer-link">Contact</NavLink>
        <NavLink to="/instructions" className="footer-link">Instructions</NavLink>
        {/* <a href="#tiktok" className="social-link">TikTok</a> */}
        {/* <a href="#instagram" className="social-link">Instagram</a> */}
      </div>
      <div className="footer-attribution">
        Indigo Studio LLC
      </div>
    </footer>
  );
}

export default Footer;